exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ccNumberLabel-5f2c25e1{display:flex;justify-content:space-between}.cards-a09c996d{width:153px;height:20px}.monthYear-a327e47c{display:flex;justify-content:space-between}.monthYear-a327e47c .month-f5e1dc63{flex:0 1 60%;margin-bottom:9px}.monthYear-a327e47c .year-600fd81f{max-width:130px;margin:0 0 9px 13px}\n", ""]);

// Exports
exports.locals = {
	"ccNumberLabel": "ccNumberLabel-5f2c25e1",
	"cards": "cards-a09c996d",
	"monthYear": "monthYear-a327e47c",
	"month": "month-f5e1dc63",
	"year": "year-600fd81f"
};